// General
import PropTypes from 'prop-types';
import React, { useState } from 'react';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal } from 'react-bootstrap';
import bt from '../../components/commonStyle.css';
import s from './LoginModal.css';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { closeLoginModal, openSignupModal } from '../../actions/modalActions';

// Components
import Link from '../Link';
import LoginForm from '../LoginForm';
import SocialLogin from '../SocialLogin';

// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

const LoginModal = () => {

  const loginModal = useSelector(state => state.modalStatus.isLoginModalOpen);
  const dispatch = useDispatch();
  const [eyeActive, setEyeActive] = useState(false);

  return (
    <>
      <Modal
        show={loginModal}
        animation={false}
        onHide={() => dispatch(closeLoginModal())}
        dialogClassName={'loginModal'}
      >
        <Modal.Body>
          <div className={s.pageWrapper}>
            {/* Top logo */}
            <img
              src="/eslipin-logo-secundario-blue.png"
              alt="Eslipin"
              className={s.primaryLogo}
            />

            {/* Main content: two columns */}
            <div className={s.mainContent}>
              {/* Left column */}
              <div className={s.leftColumn}>
                <h1 className={s.welcomeTitle}>
                  ¡Bienvenido{' '}
                  <span className={s.welcomeTitleAccent}>de nuevo!</span>
                </h1>
                <p className={s.welcomeSubtitle}>
                  Tu próxima experiencia te espera. <br />Inicia sesión y encuentra el alojamiento <br />perfecto en Bolivia.
                </p>

                {/* Feature items */}
                <div className={s.featuresList}>
                  {/* Reservas seguras */}
                  <div className={s.featureItem}>
                    <div className={s.featureIconCircle}>
                      <img
                        src="/SiteIcons/reserva_segura.svg"
                        alt="Reservas seguras"
                      />
                    </div>
                    <div className={s.featureTextGroup}>
                      <p className={s.featureTitle}>Reservas seguras</p>
                      <p className={s.featureDesc}>Protegemos tu información y tu reserva.</p>
                    </div>
                  </div>

                  {/* Soporte humano */}
                  <div className={s.featureItem}>
                    <div className={s.featureIconCircle}>
                      <img
                        src="/SiteIcons/soporte_humano.svg"
                        alt="Soporte humano"
                      />
                    </div>
                    <div className={s.featureTextGroup}>
                      <p className={s.featureTitle}>Soporte humano</p>
                      <p className={s.featureDesc}>Estamos contigo durante tu experiencia.</p>
                    </div>
                  </div>

                  {/* Alojamientos verificados */}
                  <div className={s.featureItem}>
                    <div className={s.featureIconCircle}>
                      <img
                        src="/SiteIcons/alojamientos_verificados.svg"
                        alt="Alojamientos verificados"
                      />
                    </div>
                    <div className={s.featureTextGroup}>
                      <p className={s.featureTitle}>Alojamientos verificados</p>
                      <p className={s.featureDesc}>Reserva con mayor tranquilidad y confianza.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right column: login card */}
              <div className={s.rightColumn}>
                <div className={s.root}>
                  <a
                    className={s.closeBtn}
                    onClick={() => dispatch(closeLoginModal())}
                  >
                    <span>×</span>
                  </a>

                  {/* Card header */}
                  <div className={s.cardHeader}>
                    <div className={s.cardIconWrapper}>
                      <img
                        src="/eslipin-sleep.svg"
                        alt="Eslipin"
                      />
                    </div>
                    <h2 className={s.cardTitle}>Iniciar sesión</h2>
                    <p className={s.cardSubtitle}>
                      Accede a tu cuenta para buscar, reservar y gestionar tus viajes.
                    </p>
                  </div>

                  {/* Login form */}
                  <LoginForm onEyeToggle={setEyeActive} />

                  {/* Divider */}
                  <h4 className={s.lineThrough}>
                    <span className={s.linetext}>
                      <FormattedMessage {...messages.or} />
                    </span>
                  </h4>

                  {/* Social login */}
                  <SocialLogin />

                  {/* Sign up link */}
                  <p className={s.linkText}>
                    <FormattedMessage {...messages.noAccount} />
                    <Link className={s.modalCaptionLink} onClick={() => dispatch(openSignupModal())}>
                      <FormattedMessage {...messages.signUpHere} />
                    </Link>
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom app banner */}
            <div className={s.appBanner}>
              <div className={s.appBannerLeft}>
                <img
                  src="/SiteImages/screen_login.jpg"
                  alt="Eslipin App"
                  className={s.phoneMockup}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
                <div className={s.appBannerTextGroup}>
                  <p className={s.appBannerTitle}>Lleva Eslipin contigo</p>
                  <p className={s.appBannerDesc}>
                    Reserva desde nuestra app y disfruta de una experiencia aún mejor.
                  </p>
                </div>
              </div>
              <div className={s.appBannerRight}>
                <img
                  src="/SiteImages/playStore.svg"
                  alt="Google Play"
                  className={s.storeIcon}
                />
                <img
                  src="/SiteImages/appStore.svg"
                  alt="App Store"
                  className={s.storeIcon}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

LoginModal.propTypes = {
  closeLoginModal: PropTypes.func,
  loginModal: PropTypes.bool,
  openSignupModal: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default withStyles(s, bt)(LoginModal);